import { BaseMaterialLocalModule } from './_base/base-material-local.module'
import { PropertiesWindowService } from './properties-window.service'
import { BaseComponentCustomModule } from './base-component-custom/base-component-custom.module'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PropertiesWindowFormComponent } from './properties-window-form/properties-window-form.component'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { CdkTreeModule } from '@angular/cdk/tree'
import { RouterModule } from '@angular/router'
import {
  MatFormFieldDefaultOptions,
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
} from '@angular/material/form-field'
import { PhdSoftPipesModule } from '@phdsoft/pipes'
import { PhdSoftWindowModule } from '@phdsoft/window'
import { DialogModule } from 'primeng/dialog'
import { NgxEchartsModule } from 'ngx-echarts'
import { SideBoardModule } from '@app/side-board/side-board.module'
import { ElementTypeListModule } from '@app/shared/components/element-type-list/element-type-list.module'
import { ColorPickerModule } from 'primeng/colorpicker'
import { SliderModule } from 'primeng/slider'
import { DropdownModule } from 'primeng/dropdown'

export const matFormFieldDefaultOptions: MatFormFieldDefaultOptions = {
  // appearance: 'legacy',
  appearance: 'fill',
  floatLabel: 'always',
}

@NgModule({
  declarations: [PropertiesWindowFormComponent],
  imports: [
    CommonModule,
    RouterModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    BaseMaterialLocalModule,
    BaseComponentCustomModule,
    ElementTypeListModule,
    CdkTreeModule,
    PhdSoftPipesModule,
    PhdSoftWindowModule,
    DialogModule,
    SideBoardModule,
    ColorPickerModule,
    SliderModule,
    DropdownModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ],
  exports: [PropertiesWindowFormComponent],
  providers: [
    PropertiesWindowService,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: matFormFieldDefaultOptions },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class PropertiesWindowModule {}
